import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-biz/bankInfo/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/sino-biz/bankInfo/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/sino-biz/bankInfo/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/sino-biz/bankInfo/save',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/sino-biz/bankInfo/update',
        method: 'post',
        data: row
    })
}

export const updateStatus = (row) => {
    return request({
        url: '/api/sino-biz/bankInfo/updateStatus',
        method: 'post',
        data: row
    })
}

export const getDetailByCreateUser = (createUser) => {
    return request({
        url: '/api/sino-biz/bankInfo/detailByCreateUser',
        method: 'get',
        params: {
            createUser
        }
    })
}

